<template>
  <div>
    <div>
      <v-card
        class="px-14 py-5 card_width"
        color="#F5F8F8"
        flat
        style="border-radius: 18px !important"
      >
        <!-- <router-link to="/team" style="text-decoration: none">
          <v-btn depressed color="transparent" class="d-flex justify-start">
            <v-icon color="#646464">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </router-link> -->
        <div class="d-flex justify-space-between align-center mt-9">
          <v-row>
            <v-col cols="12" md="6">
              <v-avatar size="100">
                <img :src="GetViewTeamMember.ProfileImage" alt="John" />
                <img
                  :src="imageUrl(GetViewTeamMember.ProfileImage)"
                  alt="John"
                />
              </v-avatar>
            </v-col>
            <v-col cols="12" md="6" class="d-flex align-center">
              <div class="top_btn">
                <v-dialog v-model="editdialog" width="500" persistent>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      class="px-10 text_style"
                      dark
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      >Edit</v-btn
                    >
                  </template>
                  <v-card>
                    <div class="mx-5 py-5 d-flex justify-space-between">
                      <h5>Edit Team Member</h5>
                      <v-icon @click="close">mdi-close</v-icon>
                    </div>
                    <div>
                      <edit-team-component
                        :EditTeamModel="GetViewTeamMember"
                        @close="close"
                      />
                    </div>
                  </v-card>
                </v-dialog>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-9">
          <!-- <div class="mobile_view">
            <v-row>
              <v-col cols="5" md="2">
                <div><span style="color: #a1a3a8"> ID</span></div>
                <div class="my-8">
                  <span style="color: #a1a3a8"> Full name</span>
                </div>
                <div><span style="color: #a1a3a8"> Email adderss</span></div>
                <div class="my-8">
                  <span style="color: #a1a3a8"> Role</span>
                </div>
              </v-col>

              <v-col cols="7" md="10">
                <div>
                  <span> {{ GetViewTeamMember.Id }}</span>
                </div>
                <div class="my-8">
                  <span>
                    {{ GetViewTeamMember.FirstName }}
                    {{ GetViewTeamMember.LastName }}</span
                  >
                </div>
                <div>
                  <span> {{ GetViewTeamMember.Email }}</span>
                </div>
                <div class="my-8">
                  <span> {{ GetViewTeamMember.Role }}</span>
                </div>
              </v-col>
            </v-row>
          </div> -->

          <v-row class="destop_view">
            <v-col cols="5" md="2">
              <div><span style="color: #a1a3a8"> ID</span></div>
              <div class="my-8">
                <span style="color: #a1a3a8"> Full name</span>
              </div>
              <div><span style="color: #a1a3a8"> Email adderss</span></div>
              <div class="my-8"><span style="color: #a1a3a8"> Role</span></div>
            </v-col>

            <v-col cols="7" md="10">
              <div>
                <span> {{ GetViewTeamMember?.Id }}</span>
              </div>
              <div class="my-8">
                <span>
                  {{ GetViewTeamMember.FirstName }}
                  {{ GetViewTeamMember.LastName }}</span
                >
              </div>
              <div>
                <span> {{ GetViewTeamMember.Email }}</span>
              </div>
              <div class="my-8">
                <span> {{ GetViewTeamMember.Role }}</span>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider class="my-7"></v-divider>
        <div class="mb-8">
          <v-row>
            <v-col cols="12" md="2" class="pt-0">
              <span style="color: #a1a3a8">Password </span></v-col
            >
            <v-col cols="12" md="5" class="pt-1">
              <div class="d-flex align-center">
                <span>*****************</span>

                <div>
                  <v-icon class="mx-4 mt-n3" color="#52AE32">mdi-lock</v-icon>
                </div>
                <!-- <div class="mt-n2">
                  <span class="primary--text">Change password</span>
                </div> -->
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import EditTeamComponent from "./EditTeam.component.vue";
import { mapGetters } from "vuex";

export default {
  components: { EditTeamComponent },
  name: "seeprofilecomponent",
  data() {
    return {
      IbaUrl: process.env.VUE_APP_IMG_URL,
      btnloader: false,
      editdialog: false,
      object: {
        ID: "110",
        Full_name: "Jane Doe",
        Email_address: "abc@demo.com",
        Role: "Admin",
      },
    };
  },
  computed: {
    ...mapGetters(["GetViewTeamMember", "GetTeamMembers"]),
  },
  methods: {
    imageUrl(data) {
      return data ? data : "";
    },
    close() {
      this.fetchData();
      this.editdialog = false;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.btnloader = false;
      }, 2000);
    },
    async fetchData() {
      await this.$store.dispatch("GetTeamMembers").then(() => {
        var newData = this.GetTeamMembers.find(
          (x) => x.Id == this.GetViewTeamMember?.Id
        );

        this.$store.dispatch("SetViewTeamMember", newData);
      });
    },
  },
};
</script>

<style scoped>
.top_btn {
  display: flex;
  justify-content: end;
}
/* .mobile_view {
  display: none;
} */
/* .v-card {
  border-radius: 18px !important;
} */
@media screen and (min-width: 1600px) {
  .card_width {
    width: 70%;
  }
}
@media screen and (max-width: 430px) {
  .top_btn {
    justify-content: center;
  }
  /* .destop_view {
    display: none;
  }
  .mobile_view {
    display: block;
  } */
}
</style>
